export default class BaseFilter {
    getData() {
        var _a;
        return {
            key: (_a = this.$node.attr("name")) !== null && _a !== void 0 ? _a : "unkown",
            value: this.$node.val()
        };
    }
    loadData(data) {
        var _a;
        const key = (_a = this.$node.attr("name")) !== null && _a !== void 0 ? _a : "unkown";
        for (let i = 0; i < data.length; i++) {
            if (data[i].key === key) {
                this.setValue(data[i].value);
            }
        }
    }
    setValue(value) {
        this.$node.val(value);
        this.$node.trigger('change');
    }
    checkParameterForInitValue() {
        const name = this.$node.attr("name");
        if (name === undefined || !name)
            return;
        let params = new URLSearchParams(document.location.search);
        let value = params.get(name);
        if (value === undefined || !value)
            return;
        this.setValue(value);
        params.delete(name);
        let newUrl = location.pathname;
        let args = params.toString();
        if (args.length > 0) {
            newUrl += `?${params}`;
        }
        window.history.replaceState({}, '', newUrl);
    }
}
